import { Divider } from "@mui/material";
import React from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { Orders } from './Orders';
import { OrderDetails } from "./OrderDetails";
import { UserDetails } from "./UserDetails";
import { Address } from "./Address";
import { useAppDispatch } from "../../../State/Store";
import { logout } from "../../../State/AuthSlice";


const menu = [
  { name: "Orders", path: "/account/orders" },
  { name: "Profile", path: "/account" },
  // { name: "Saved Cards", path: "/account/saved-cards" },
  { name: "Addresses", path: "/account/addresses" },
  { name: "Logout", path: "/" },
];
export const Account = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch()
  //use it instead of href for a tag
  const handleClick=async(item:any)=>{
    if(item.name=="Logout"){
     
    await  dispatch(logout(navigate))
      
    }else{

      navigate(item.path)
    }
  }
  const location = useLocation();
  return (
    <div className="px-5 lg:px-52 min-h-screen mt-10">
      <div className="">
        {/* <h1 className="text-xl font-bold pb-5">Jane</h1> */}
      </div>
      <Divider />
      <div className="grid grid-cols-1 lg:grid-cols-3 lg:min-h-[78vh]">
        {/* left side */}
        <section className="col-span-1 lg:border-r lg:pr-5  py-5 h-full">
          {menu.map((item, index) => (
            <div
              onClick={()=>handleClick(item)}
              className={`
                ${item.path===location.pathname?"bg-primary text-white":""}
                py-3 cursor-pointer border-b hover:text-white hover:bg-primary px-5 rounded-md `}
              key={index}
            >
              <p>{item.name}</p>
              
            </div>
          ))}
        </section>
        {/* right side */}
        <section className="right lg:col-span-2 py-5">
          <Routes>
            <Route path="/" element={<UserDetails/>}/>
            <Route path="/orders" element={<Orders/>}/>
            <Route path="/order/:orderId/:orderItemId" element={<OrderDetails/>}/>
            <Route path="/addresses" element={<Address/>}/>
          </Routes>
          
        </section>
      </div>
    </div>
  );
};
